import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { LoginService } from "./login.service";
import { ApiUtilityService } from "app/shared/api-utility";
import { NotifyType } from "app/shared/enums";

@Component({
  selector: "login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: LoginService,
    private apiUtilityService: ApiUtilityService
  ) {}

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.authenticationService
      .login(this.f.username.value, this.f.password.value)
      .pipe(first())
      .subscribe(
        (data) => {
          // Only allow the Hangfire origin as an external destination.
          try {
            const destination = new URL(this.returnUrl);
            if (destination.origin === "https://api.mahdinobakht.ir" &&
                (destination.pathname === "/hangfire" || destination.pathname.startsWith("/hangfire/"))) {
              window.location.assign(destination.href);
              return;
            }
          } catch (_) { }
          const localReturnUrl = this.returnUrl.startsWith("/") && !this.returnUrl.startsWith("//")
            ? this.returnUrl : "/dashboard";
          this.router.navigateByUrl(localReturnUrl);
        },
        (error) => {
          this.apiUtilityService.toastShow(
            "نام کاربری یا کلمه عبور اشتباه است",
            NotifyType.error
          );
          this.loading = false;
        }
      );
  }
}
